import { Pagination } from "@/modules/common/types/Pagination";
import api from "../api";
import { ListAdminAuditLogsDto } from "../dto/admin-audit-logs";
import { AdminAuditLogDetailResponse, AdminAuditLogListResponse, AdminAuditLogOptionsResponse } from "../response/admin-audit-logs";

export const ADMIN_AUDIT_LOGS_ENDPOINTS = {
  GET_LOGS: "/v1/admin/audit-logs",
  GET_UNIQUE_LOG: (id: string) => `/v1/admin/audit-logs/${id}`,
  GET_LOGS_FILTER_OPTIONS: "/v1/admin/audit-logs/filter-options",
};

export const AdminAuditLogsService = {
  getLogs: async (params?: ListAdminAuditLogsDto): Promise<Pagination<AdminAuditLogListResponse>> => {
    const response = await api.get(ADMIN_AUDIT_LOGS_ENDPOINTS.GET_LOGS, {
      params,
      paramsSerializer: {
        indexes: null,
      },
    });
    return response.data;
  },

  getUniqueLog: async (id: string): Promise<AdminAuditLogDetailResponse> => {
    const response = await api.get(ADMIN_AUDIT_LOGS_ENDPOINTS.GET_UNIQUE_LOG(id));
    return response.data;
  },

  getAuditOptions: async (): Promise<AdminAuditLogOptionsResponse> => {
    const response = await api.get(ADMIN_AUDIT_LOGS_ENDPOINTS.GET_LOGS_FILTER_OPTIONS);
    return response.data;
  },
};
